import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import TransitionGroup from 'react-transition-group/cjs/TransitionGroup';
/* styles */
import './right-side-bar.scss';

class RightSideBar extends React.PureComponent {
  render() {
    let className = 'glu-right-sidebar clearfix';
    let sideBarClassName = 'glu-right-sidebar__panel-container';
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }
    if (this.props.isCollapsed) {
      className += ' glu-right-sidebar--collapsed';
    }
    if (this.props.isMobileDevice) {
      className += ' glu-right-sidebar--full-width';
      sideBarClassName += ' glu-right-sidebar__panel-container--full-width';
    }
    return (
      <aside className={className}>
        {this.props.buttonRenderer && (
          <div className="glu-right-sidebar__button-container">{this.props.buttonRenderer()}</div>
        )}
        <TransitionGroup timeout={200} className={sideBarClassName}>
          {this.props.children}
        </TransitionGroup>
      </aside>
    );
  }
}

RightSideBar.propTypes = {
  buttonRenderer: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  isCollapsed: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
};

RightSideBar.defaultProps = {
  buttonRenderer: undefined,
  children: null,
  className: '',
  isCollapsed: true,
  isMobileDevice: false,
};

function mapStateToProps(state) {
  return {
    isMobileDevice: state.userReducer.isMobileDevice,
  };
}

export default connect(mapStateToProps)(RightSideBar);
